import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'price',
  standalone: true,
})
export class PricePipe implements PipeTransform {
  transform(value: number | string, decimals = 2): string {
    const valueAsNumber = Number(value);
    if (valueAsNumber > Math.floor(valueAsNumber)) {
      return valueAsNumber.toFixed(decimals).replace('.', ',');
    }
    return Math.floor(valueAsNumber).toString();
  }
}
